import type { Shop } from '@@partner:types:app'

import { gql, useQuery } from '@apollo/client'

export interface BrandShopsVariables {}

export interface BrandShops {
  shops: Shop[]
}

export const GQL_QUERY_ORDER = gql`
  query {
    shops: brandShops {
      id
      name
      address
      status
      geoPoint: shopGeoPoint {
        longitude
        latitude
      }
    }
  }
`

export const useFetchBrandShops = () => {
  return useQuery<BrandShops, BrandShopsVariables>(GQL_QUERY_ORDER)
}
